import { createFileRoute, useSearch } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { InstancesView } from '@/components/features/checklist-management/components/instances';

export const Route = createFileRoute('/_authenticated/checklist-management/instances')({
  validateSearch: (search: Record<string, unknown>) => ({
    instanceId: (search.instanceId as string) || undefined,
    page: search.page ? Number(search.page) : 1,
    limit: search.limit ? Number(search.limit) : 10,
  }),
  component: ChecklistInstances,
});

function ChecklistInstances() {
  const search = useSearch({ from: '/_authenticated/checklist-management/instances' });
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-balance">
          {t('checklistManagement.instances.title')}
        </h1>
        <p className="text-xs sm:text-sm text-muted-foreground">
          {t('checklistManagement.instances.description')}
        </p>
      </div>
      <InstancesView initialInstanceId={search.instanceId} />
    </div>
  );
}
